import { useEffect } from "react"
import { useTranslation } from "react-i18next"

const HEADER_LABEL_KEYS = {
  "": "Normal",
  1: "Heading 1",
  2: "Heading 2",
  3: "Heading 3",
  4: "Heading 4",
  5: "Heading 5",
  6: "Heading 6",
}

const applyQuillHeaderLabels = t => {
  document.querySelectorAll(".ql-snow .ql-picker.ql-header").forEach(picker => {
    picker.querySelectorAll(".ql-picker-item").forEach(item => {
      const value = item.getAttribute("data-value") ?? ""
      const key = HEADER_LABEL_KEYS[value] || HEADER_LABEL_KEYS[""]
      const label = t(key)
      item.setAttribute("data-label", label)
    })

    const labelEl = picker.querySelector(".ql-picker-label")
    if (!labelEl) return
    const selectedValue = labelEl.getAttribute("data-value") ?? ""
    const key = HEADER_LABEL_KEYS[selectedValue] || HEADER_LABEL_KEYS[""]
    labelEl.setAttribute("data-label", t(key))
  })
}

/**
 * Translate Quill toolbar header picker labels for the active locale.
 * Quill often mounts after loading, so we retry + observe DOM changes.
 *
 * @param {boolean} ready - set false while editors are not mounted yet
 */
const useTranslatedQuillHeaders = (ready = true) => {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    if (!ready) return undefined

    const apply = () => applyQuillHeaderLabels(t)
    apply()

    const timers = [0, 50, 150, 400, 800].map(delay =>
      window.setTimeout(apply, delay)
    )

    const observer = new MutationObserver(() => apply())
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-value", "class"],
    })

    return () => {
      timers.forEach(id => window.clearTimeout(id))
      observer.disconnect()
    }
  }, [ready, t, i18n.language])
}

export default useTranslatedQuillHeaders
